import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6 13h13v3H6zm0-5h13v3H6z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 6v12h17V6H4zm15 10H6v-3h13v3zm0-5H6V8h13v3z"
})), 'ViewStreamTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewStreamTwoTone.js
// module id = 7124
// module chunks = 2